// ---------------------------------------------------------
// Datei: maintenance.ts
// Zweck: Typisierter One360-Client für Serviceprotokolle und Anhänge.
// Kontext: Komponenten kommunizieren ausschließlich über services/api.
// Stand: 2026-07-29
// ---------------------------------------------------------
import one360 from './one360';
import type {
  MaintenanceProtocol,
  MaintenanceProtocolProjectDetails,
  MaintenanceProtocolUpsertPayload,
} from '../../interfaces/maintenance';

const basePath = (projectId: string) => `/api/v1/ops/projects/${encodeURIComponent(projectId)}/maintenances`;

export const getMaintenanceProtocols = (projectId: string): Promise<MaintenanceProtocol[]> =>
  one360.get<MaintenanceProtocol[]>(basePath(projectId));

export const upsertMaintenanceProtocol = (
  projectId: string,
  protocolId: string,
  payload: MaintenanceProtocolUpsertPayload,
): Promise<MaintenanceProtocol> =>
  one360.put<MaintenanceProtocol>(`${basePath(projectId)}/${encodeURIComponent(protocolId)}`, payload);

export const deleteMaintenanceProtocol = async (projectId: string, protocolId: string): Promise<void> => {
  await one360.delete(`${basePath(projectId)}/${encodeURIComponent(protocolId)}`);
};

export const uploadMaintenanceAttachment = async (
  projectId: string,
  protocolId: string,
  dealName: string,
  file: File,
): Promise<MaintenanceProtocol> => {
  const data = new FormData();
  data.append('file', file);
  data.append('dealName', dealName);
  return one360.post<MaintenanceProtocol>(`${basePath(projectId)}/${encodeURIComponent(protocolId)}/attachments`, data);
};

export const finalizeMaintenanceProtocol = (
  projectId: string,
  protocolId: string,
  dealName: string,
  projectDetails?: MaintenanceProtocolProjectDetails,
): Promise<MaintenanceProtocol> =>
  one360.post<MaintenanceProtocol>(`${basePath(projectId)}/${encodeURIComponent(protocolId)}/finalize`, {
    dealName,
    projectDetails,
  });
